import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ReactToPrint from "react-to-print";
import { Button } from 'primereact/button'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import RelatorioProcessoService from '../../app/service/RelatorioProcessoService'
import LocalStorageService from '../../app/service/localStorageService'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import PessoaService from '../../app/service/PessoaService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import ObjetoAcaoService from '../../app/service/ObjetoAcaoService'
import TipoPagamentoService from '../../app/service/TipoPagamentoService'
import TiposCustasService from '../../app/service/TiposCustasService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import RitoService from '../../app/service/RitoService'
import MotivoResultadoService from '../../app/service/MotivoResultadoService'
import UsuarioService from '../../app/service/UsuarioService'

import '../financeiro/financeiro.css'
import './relatorioProcesso.css'

import imagemRelatorio from '../../pages/seguranca/img/ilaw-logo.png'

class ComponentToPrintRelatorioProcesso extends React.Component {
  constructor(props) {
    super(props); 

    this.state = {
      nomeUsuario: '',
      dataImpressao: '',
      horaImpressao: '',
      filtro: null,
      quantidade: '',
    }
  }

  componentDidMount() {
  
    var dayName = new Array ("domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado")
    var monName = new Array ("janeiro", "fevereiro", "março", "abril", "Maio", "junho", "agosto", "outubro", "novembro", "dezembro")

    var data = new Date();

    var dataCompleta = dayName[data.getDay() ] + ", " + data.getDate () + " de " + monName [data.getMonth() ]   +  " de "  +     data.getFullYear ()

    var hora = data.getHours() + ":" + data.getMinutes() + ":" + data.getSeconds()

    this.setState({dataImpressao: dataCompleta});
    this.setState({horaImpressao: hora});
  }

  render() {
    return (
      <div>
        <br></br>
        <div style={{margin: '38px'}}>
            <div>
              <img src={imagemRelatorio} width="200" height="140"/>
            </div>
            <span className="relatorio">Relatório de Processos</span>
            <div>
              Impresso por: {this.props.nomeUsuario} &nbsp; 
              em: {this.state.dataImpressao}&nbsp;
              {this.state.horaImpressao}
            </div>
            <div>
              <span className="filtro">Filtros:&nbsp;{this.props.filtro}</span>
            </div>
            <div>
              Quantidade de Registros:&nbsp;{this.props.quantidade}
            </div>
            
            <hr></hr>
        </div>
        
        <div style={{margin: '46px'}}>
          <DataTable value={this.props.dados}  alwaysShowPaginator responsiveLayout="scroll" id="idRelatorio"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" "
                              paginatorRight selectionMode="multiple">
                                
              <Column style={{background: 'none', display: `${this.props.exibirNumeroProcesso}`}} field="numeroProcesso" header="N. Processo"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirNumeroCnj}`}} field="numeroCnj" header="N. CNJ"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPasta}`}} field="pasta" header="Pasta"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirCliente}`}} field="autores" header="Autore(s)"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirParteContraria}`}} field="reus" header="Réu(s)"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirAdvogado}`}} field="advogados" header="Outras Partes"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirTipoDecisao}`}} field="tipoDecisao" header="Tipo Decisão"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirTipoAcao}`}} field="tipoAcao" header="Tipo Ação"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirAreaAtuacao}`}} field="areaAtuacao" header="Área Atuação"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataDecisao}`}} field="dataDecisao" header="Dt. Decisão"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataCadastro}`}} field="dataCadastro" header="Dt. Cadastro"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataSentenca}`}} field="dataSentenca" header="Dt. Sentença"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataAlteracao}`}} field="dataAlteracao" header="Dt. Alteração"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataDistribuicao}`}} field="dataDistribuicao" header="Dt. Distribuição"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirStatusProcessual}`}} field="statusProcessual" header="Status Processual"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirGrupoTrabalho}`}} field="grupoTrabalho" header="G. Trabalho"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirObjetoAcao}`}} field="objetos" header="Obj. Ação"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPagamento}`}} field="pagamentos" header="Pagamentos"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorPagamento}`}} field="valorPagamentos" header="Vlr. Pagamentos"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirCustas}`}} field="custas" header="Custas"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorCustas}`}} field="valorCustas" header="Vlr. Custas"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPedidos}`}} field="pedidos" header="Pedidos"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorProvavel}`}} field="valorProvavel" header="Vlr. Provável"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorPossivel}`}} field="valorPossivel" header="Vlr. Possível"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorRemoto}`}} field="valorRemoto" header="Vlr. Remoto"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirValorCausa}`}} field="valorCausa" header="Vlr. Causa"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPush}`}} field="snPush" header="Push"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPushEmail}`}} field="snEmail" header="Push Email"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirPushHistorico}`}} field="snHistorico" header="Push Histórico"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirAtividade}`}} field="ultimaAtividade" header="Ult. Atividade"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataUltimaAtividade}`}} field="dataUltimaAtividade" header="Dt. Ult. Atividade"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirUltimoHistorico}`}} field="ultimoHistorico" header="Ult. Histórico"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataUltimoHistorico}`}} field="dataUltimoHistorico" header="Dt. Ult. Histórico"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirRito}`}} field="rito" header="Rito"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirMotivoResultado}`}} field="motivoResultado" header="Motivo Resultado"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirUf}`}} field="uf" header="UF"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirComarca}`}} field="comarca" header="Comarca"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirDataArquivamento}`}} field="dataArquivamento" header="Data Arquivamento"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirImportanteEmpresa}`}} field="importanteEmpresa" header="Importante Empresa"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirImportanteParaMim}`}} field="importanteParaMim" header="Importante para Mim"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirEstrategico}`}} field="estrategico" header="Estratégico"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirResponsavel}`}} field="responsavel" header="Responsável"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirObservacao}`}} field="observacao" header="Observação"></Column>
              <Column style={{background: 'none', display: `${this.props.exibirBanca}`}} field="banca" header="Banca"></Column>
            </DataTable>
        </div>
      </div>
    );
  }
}

class RelatorioProcessoResult extends React.Component {
  constructor(props) {
    super(props)

    this.relatorioProcessoService = new RelatorioProcessoService();
    this.pessoaService = new PessoaService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.objetoAcaoService = new ObjetoAcaoService();
    this.tipoPagamentoService = new TipoPagamentoService();
    this.tiposCustasService = new TiposCustasService();
    this.statusProcessualService = new StatusProcessualService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.tipoAcaoService = new TipoAcaoService();
    this.ritoService = new RitoService();
    this.motivoResultadoService = new MotivoResultadoService();
    this.usuarioService = new UsuarioService();

    this.state = {
      pessoas: [],
      nomePessoa: '',
      gruposTrabalho: [],
      objetosAcao: [],
      pagamentos: [],
      custas: [],
      statusProcessual: [],
      tipoAcao: null,
      areaAtuacao: null,
      tipoDecisao: null,
      rito: null,
      motivoResultado: null,
      uf: null,
      nomeUsuario: '',
      responsavel: null,
      banca: null,
      relatorioResult: [],
      campoNumeroProcesso: '',
      campoNumeroCnj: '',
      campoPasta: '',
      campoCliente: '',
      campoParteContraria: '',
      campoAdvogado: '',
      campoTipoDecisao: '',
      campoTipoAcao: '',
      campoAreaAtuacao: '',
      campoDataDecisao: '',
      campoDataCadastro: '',
      campoDataDataSentenca: '',
      campoDataAlteracao: '',
      campoDataDistribuicao: '',
      campoStatusProcessual: '',
      campoGrupoTrabalho: '',
      campoObjetoAcao: '',
      campoGarantia: '',
      campoValorGarantia: '',
      campoPagamento: '',
      campoValorPagamento: '',
      campoCustas: '',
      campoValorCustas: '',
      campoPush: '',
      campoPushEmail: '',
      campoPushHistorico: '',
      campoAtividade: '',
      campoDataUltimaAtividade: '',
      campoUltimoHistorico: '',
      campoDataUltimoHistorico: '',
      campoPedidos: '',
      campoValorProvavel: '',
      campoValorPossivel: '',
      campoValorRemoto: '',
      campoValorCausa: '',
      campoRito: '',
      campoMotivoResultado: '',
      campoUf: '',
      campoComarca: '',
      campoDataArquivameno: '',
      campoImportanteEmpresa: '',
      campoImportanteParaMim: '',
      campoEstrategico: '',
      campoResponsavel: '',
      campoObservacao: '',
      campoBanca: '',
      filtro: '',
      openSpinner: false,
    }
  }

  consultarResponavel = async (codigo) => {
    await this.usuarioService.consultarUsuario(codigo)
      .then(response => {
        this.setState({responsavel: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Responsáveis', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarBanca = async (codigo) => {
    await this.pessoaService.consultarPessoa(codigo)
      .then(response => {
        this.setState({banca: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarPessoa = async (pessoas) => {
    await this.pessoaService.consultarPessoasPorCodigos(pessoas)
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarGrupoTrabalho = async (codigos) => {
    await this.grupoTrabalhoService.consultarGruposPorCodigos(codigos)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Grupos de Trabalho', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarObjetosAcao = async (codigos) => {
    await this.objetoAcaoService.consultarObjetosPorCodigos(codigos)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Objetos de Ação', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarPagamentos = async (codigos) => {
    await this.tipoPagamentoService.consultarTiposPagamentosPorCodigos(codigos)
      .then(response => {
        this.setState({pagamentos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Pagamentos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarCustas = async (codigos) => {
    await this.tiposCustasService.consultarTiposCustosPorCodigos(codigos)
      .then(response => {
        this.setState({custas: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Custas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarStatusProcessual = async (codigos) => {
    await this.statusProcessualService.consultarStatusProcessualPorCodigos(codigos)
      .then(response => {
        this.setState({statusProcessual: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Status Processual', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarTipoAcao = async (codigo) => {
    await this.tipoAcaoService.consultarTipo(codigo)
      .then(response => {
        this.setState({tipoAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta de Tipo de Ação', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarAreaAtuacao = async (codigo) => {
    await this.areaAtuacaoService.consultarAreaAtuacao(codigo)
      .then(response => {
        this.setState({areaAtuacao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consulta Área de Atuação', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarTipoDecisao = async (codigo) => {
    await this.tipoDecisaoService.consultarTipoDecisao(codigo)
      .then(response => {
        this.setState({tipoDecisao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consultar Tipo de Decisão', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarRito = async (codigo) => {
    await this.ritoService.consultar(codigo)
      .then(response => {
        this.setState({rito: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consultar Rito de Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarMotivoResultado = async (codigo) => {
    await this.motivoResultadoService.consultar(codigo)
      .then(response => {
        this.setState({motivoResultado: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos - Consultar Motivo de Resultado', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarRelatorio = async (params) => {
    const filtro = {
      empresa: params.empresa,
      usuario: params.usuario,
      pessoa: params.pessoa,
      dataDecisaoInicial: params.dataDecisaoInicial,
      dataDecisaoFinal: params.dataDecisaoFinal,
      dataSentencaInicial: params.dataSentencaInicial,
      dataSentencaFinal: params.dataSentencaFinal,
      dataDistribuicaoInicial: params.dataDistribuicaoInicial,
      dataDistribuicaoFinal: params.dataDistribuicaoFinal,
      dataCadastroInicial: params.dataCadastroInicial,
      datacadastroFinal: params.dataCadastroFinal,
      dataAlteracaoInicial: params.dataAlteracaoInicial,
      dataAlteracaoFinal: params.dataAlteracaoFinal,
      grupoTrabalho: params.grupoTrabalho,
      objetoAcao: params.objetoAcao,
      pagamento: params.pagamento,
      operadorLogicoPagamento: params.operadorLogicoPagamentos,
      valorPagamento: params.valorPagamento,
      custas: params.custas,
      operadorLogicoCustas: params.operadorLogicoCustas,
      valorCustas: params.valorCustas,
      statusProcessual: params.statusProcessual,
      tipoAcao: params.tipoAcao,
      areaAtuacao: params.areaAtuacao,
      tipoDecisao: params.tipoDecisao,
      excetoArquivados: params.excetoArquivados,
      importanteEmpresa: params.importanteEmpresa,
      importanteParaMim: params.importanteParaMim,
      estrategico: params.estrategico,
      responsavel: params.responsavel,
      pedidos: params.pedidos,
      rito: params.rito,
      motivoResultado: params.motivoResultado,
      uf: params.uf,
      dataArquivamentoInicial: params.dataArquivamentoInicial,
      dataArquivamentoFinal: params.dataArquivamentoFinal,
      banca: params.banca
    }

    let strFiltro = '';
  
    if(filtro.pessoa != '0') {
      await this.consultarPessoa(filtro.pessoa);
      strFiltro = strFiltro + ',Pessoa(s): [';
      for(let i = 0; i < this.state.pessoas.length; i++) {
        strFiltro = strFiltro + this.state.pessoas[i].nome + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.dataDecisaoInicial != '0' && filtro.dataDecisaoFinal != '0') {
      strFiltro = strFiltro + ',Data de Decisão: [' + filtro.dataDecisaoInicial + ' a ' + filtro.dataDecisaoFinal + ']';
    }

    if(filtro.dataSentencaInicial != '0' && filtro.dataSentencaFinal != '0') {
      strFiltro = strFiltro + ',Data de Sentença: [' + filtro.dataSentencaInicial + ' a ' + filtro.dataSentencaFinal + ']';
    }

    if(filtro.dataDistribuicaoInicial != '0' && filtro.dataDistribuicaoFinal != '0') {
      strFiltro = strFiltro + ',Data de Distribuição: [' + filtro.dataDistribuicaoInicial + ' a ' + filtro.dataDistribuicaoFinal + ']';
    }

    if(filtro.dataCadastroInicial != '0' && filtro.datacadastroFinal != '0') {
      strFiltro = strFiltro + ',Data de Cadastro: [' + filtro.dataCadastroInicial + ' a ' + filtro.datacadastroFinal + ']'; 
    }

    if(filtro.dataAlteracaoInicial != '0' && filtro.dataAlteracaoFinal != '0') {
      strFiltro = strFiltro + ',Data Alteração: [' + filtro.dataAlteracaoInicial + ' a ' + filtro.dataAlteracaoFinal + ']';
    }

    if(filtro.dataArquivamentoInicial != '0' && filtro.dataArquivamentoFinal != '0') {
      strFiltro = strFiltro + ',Data de Arquivamentto: [' + filtro.dataArquivamentoInicial + ' a ' + filtro.dataArquivamentoFinal + ']';
    }

    if(filtro.grupoTrabalho != '0') {
      await this.consultarGrupoTrabalho(filtro.grupoTrabalho);
      strFiltro = strFiltro + ',Grupos de Trabalho: [';
      for(let i = 0; i < this.state.gruposTrabalho.length; i++) {
        strFiltro = strFiltro + this.state.gruposTrabalho[i].nome + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.objetoAcao != '0') {
      await this.consultarObjetosAcao(filtro.objetoAcao);
      strFiltro = strFiltro + ',Objetos de Ação: [';
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        strFiltro = strFiltro + this.state.objetosAcao[i].nome + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.pagamento != '0') {
      await this.consultarPagamentos(filtro.pagamento);
      strFiltro = strFiltro + ',Pagamento(s): [';
      for(let i = 0; i < this.state.pagamentos.length; i++) {
        strFiltro = strFiltro + this.state.pagamentos[i].nome + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.custas != '0') {
      await this.consultarCustas(filtro.custas);
      strFiltro = strFiltro + ',Custas: [';
      for(let i = 0; i < this.state.custas.length; i++) {
        strFiltro = strFiltro + this.state.custas[i].nome + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.responsavel != '0') {
      await this.consultarResponavel(filtro.responsavel);
      strFiltro = strFiltro + ',Responsável: ' + this.state.responsavel.nome;
    }

    if(filtro.banca != '0') {
      await this.consultarBanca(this.state.banca);
      strFiltro = strFiltro + ',Banca: ' + this.state.banca.nome;
    }

    if(filtro.statusProcessual != '0') {
      await this.consultarStatusProcessual(filtro.statusProcessual);
      strFiltro = strFiltro + ',Status Processual: [';
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        strFiltro = strFiltro + this.state.statusProcessual[i].descricao + ',';
      }
      strFiltro = strFiltro + ']';
    }

    if(filtro.tipoAcao != '0') {
      await this.consultarTipoAcao(filtro.tipoAcao);
      strFiltro = strFiltro + ',Tipo de Ação: ' + this.state.tipoAcao.nome;
    }

    if(filtro.areaAtuacao != '0') {
      await this.consultarAreaAtuacao(filtro.areaAtuacao);
      strFiltro = strFiltro + ',Área de Atuação: ' + this.state.areaAtuacao.nome;
    }

    if(filtro.tipoDecisao != '0') {
      await this.consultarTipoDecisao(filtro.tipoDecisao);
      strFiltro = strFiltro + ',Tipo de Decisão: ' + this.state.tipoDecisao.nome;
    }

    if(filtro.rito != '0') {
      await this.consultarRito(filtro.rito);
      strFiltro = strFiltro + ',Rito: ' + this.state.rito.nome;
    }

    if(filtro.motivoResultado != '0') {
      await this.consultarMotivoResultado(filtro.motivoResultado);
      strFiltro = strFiltro + ',Motivo Resultado: ' + this.state.motivoResultado.nome;
    }

    if(filtro.uf != '0') {
      strFiltro = strFiltro + ',UF: ' + filtro.uf;
    }

    if(filtro.importanteEmpresa != '0') {
      strFiltro = strFiltro + 'Importante Empresa: ' + filtro.importanteEmpresa;
    }

    if(filtro.importanteParaMim != '0') {
      strFiltro = strFiltro + ',Importante para Mim: ' + filtro.importanteParaMim;
    }

    if(filtro.estrategico != '0') {
      strFiltro = strFiltro + ',Estratégico: ' + filtro.estrategico;
    }

    this.setState({filtro: strFiltro});

    this.setState({openSpinner: true});
    await this.relatorioProcessoService.relatorioProcesso(filtro)
      .then(response => {
        this.setState({campoNumeroProcesso: params.campoNumeroProcesso});
        this.setState({campoNumeroCnj: params.campoNumeroCnj});
        this.setState({campoPasta: params.campoPasta});
        this.setState({campoCliente: params.campoCliente})
        this.setState({campoParteContraria: params.campoParteContraria});
        this.setState({campoAdvogado: params.campoAdvogado});
        this.setState({campoTipoDecisao: params.campoTipoDecisao});
        this.setState({campoTipoAcao: params.campoTipoAcao});
        this.setState({campoAreaAtuacao: params.campoAreaAtuacao});
        this.setState({campoDataDecisao: params.campoDataDecisao});
        this.setState({campoDataCadastro: params.campoDataCadastro});
        this.setState({campoDataSentenca: params.campoDataSentenca});
        this.setState({campoDataAlteracao: params.campoDataAlteracao});
        this.setState({campoDataDistribuicao: params.campoDataDistribuicao});
        this.setState({campoStatusProcessual: params.campoStatusProcessual});
        this.setState({campoGrupoTrabalho: params.campoGrupoTrabalho});
        this.setState({campoObjetoAcao: params.campoObjetoAcao});
        this.setState({campoGarantia: params.campoGarantia});
        this.setState({campoValorGarantia: params.campoValorGarantia});
        this.setState({campoPagamento: params.campoPagamento});
        this.setState({campoValorPagamento: params.campoValorPagamento});
        this.setState({campoCustas: params.campoCustas});
        this.setState({campoValorCustas: params.campoValorCustas});
        this.setState({campoPush: params.campoPush});
        this.setState({campoPushEmail: params.campoPushEmail});
        this.setState({campoPushHistorico: params.campoPushHistorico});
        this.setState({campoAtividade: params.campoAtividade});
        this.setState({campoDataUltimaAtividade: params.campoDataUltimaAtividade});
        this.setState({campoUltimoHistorico: params.campoUltimoHistorico});
        this.setState({campoDataUltimoHistorico: params.campoDataUltimoHistorico});
        this.setState({campoPedidos: params.campoPedidos});
        this.setState({campoValorProvavel: params.campoValorProvavel});
        this.setState({campoValorPossivel: params.campoValorPossivel});
        this.setState({campoValorRemoto: params.campoValorRemoto});
        this.setState({campoValorCausa: params.campoValorCausa});
        this.setState({campoRito: params.campoRito});
        this.setState({campoMotivoResultado: params.campoMotivoResultado});
        this.setState({campoUf: params.campoUf});
        this.setState({campoComarca: params.campoComarca});
        this.setState({campoDataArquivamento: params.campoDataArquivamento});
        this.setState({campoImportanteEmpresa: params.campoImportanteEmpresa});
        this.setState({campoImportanteParaMim: params.campoImportanteParaMim});
        this.setState({campoEstrategico: params.campoEstrategico});
        this.setState({campoResponsavel: params.campoResponsavel});
        this.setState({campoObservacao: params.campoObservacao});
        this.setState({campoBanca: params.campoBanca});
        this.setState({relatorioResult: response.data});
        this.setState({quantidade: response.data.length});
      }).catch(error => {
        console.log('Erro', error);
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({nomeUsuario: usuarioLogado.nome});
    const params = this.props.match.params;
    await this.consultarRelatorio(params);
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="formGroup">
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={this.state.openSpinner}>
                <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
              </Backdrop>
                <ReactToPrint
                  trigger={() => <a className="cursor" >Imprimir</a>}
                  content={() => this.componentRef}>
                </ReactToPrint>
                <ComponentToPrintRelatorioProcesso dados={this.state.relatorioResult}
                                  nomeUsuario={this.state.nomeUsuario}
                                  quantidade={this.state.quantidade}
                                  exibirNumeroProcesso={this.state.campoNumeroProcesso}
                                  exibirNumeroCnj={this.state.campoNumeroCnj}
                                  exibirPasta={this.state.campoPasta}
                                  exibirCliente={this.state.campoCliente}
                                  exibirParteContraria={this.state.campoParteContraria}
                                  exibirAdvogado={this.state.campoAdvogado}
                                  exibirTipoDecisao={this.state.campoTipoDecisao}
                                  exibirTipoAcao={this.state.campoTipoAcao}
                                  exibirTipoAcao={this.state.campoTipoAcao}
                                  exibirAreaAtuacao={this.state.campoAreaAtuacao}
                                  exibirDataDecisao={this.state.campoDataDecisao}
                                  exibirDataCadastro={this.state.campoDataCadastro}
                                  exibirDataSentenca={this.state.campoDataSentenca}
                                  exibirDataAlteracao={this.state.campoDataAlteracao}
                                  exibirDataDistribuicao={this.state.campoDataDistribuicao}
                                  exibirStatusProcessual={this.state.campoStatusProcessual}
                                  exibirGrupoTrabalho={this.state.campoGrupoTrabalho}
                                  exibirObjetoAcao={this.state.campoObjetoAcao}
                                  exibirGarantia={this.state.campoGarantia}
                                  exibirValorGarantia={this.state.campoValorGarantia}
                                  exibirPagamento={this.state.campoPagamento}
                                  exibirValorPagamento={this.state.campoValorPagamento}
                                  exibirCustas={this.state.campoCustas}
                                  exibirValorCustas={this.state.campoValorCustas}
                                  exibirPush={this.state.campoPush}
                                  exibirPushEmail={this.state.campoPushEmail}
                                  exibirPushHistorico={this.state.campoPushHistorico}
                                  exibirAtividade={this.state.campoDataUltimaAtividade}
                                  exibirDataUltimaAtividade={this.state.campoDataUltimaAtividade}
                                  exibirUltimoHistorico={this.state.campoUltimoHistorico}
                                  exibirDataUltimoHistorico={this.state.campoDataUltimoHistorico}
                                  exibirPedidos={this.state.campoPedidos}
                                  exibirValorProvavel={this.state.campoValorProvavel}
                                  exibirValorPossivel={this.state.campoValorPossivel}
                                  exibirValorRemoto={this.state.campoValorRemoto}
                                  exibirValorCausa={this.state.campoValorCausa}
                                  exibirRito={this.state.campoRito}
                                  exibirMotivoResultado={this.state.campoMotivoResultado}
                                  exibirUf={this.state.campoUf}
                                  exibirComarca={this.state.campoComarca}
                                  exibirDataArquivamento={this.state.campoDataArquivamento}
                                  exibirImportanteEmpresa={this.state.campoImportanteEmpresa}
                                  exibirImportanteParaMim={this.state.campoImportanteParaMim}
                                  exibirEstrategico={this.state.campoEstrategico}
                                  exibirResponsavel={this.state.campoResponsavel}
                                  exibirObservacao={this.state.campoObservacao}
                                  exibirBanca={this.state.campoBanca}
                                  quantidade={this.state.quantidade}
                                  filtro={this.state.filtro}
                                  ref={el => (this.componentRef = el)} />
              </div>
            </div>
          </div> 
        </section>
      </div>
    );
  }
}
RelatorioProcessoResult.contextType = AuthContext;
export default withRouter(RelatorioProcessoResult)
